import { createSlice } from "@reduxjs/toolkit";

interface loadingBar {
    value: boolean,
};

const initialState: loadingBar = {
    value: false
}

export const loadingSlice = createSlice({
    name: "loading",
    initialState: initialState,
    reducers: {
        startLoading: (state) => {
            state.value = true;
        },
        stopLoading: (state) => {
            state.value = false;
        },
    },
});

export const { startLoading, stopLoading } = loadingSlice.actions;
export const getLoadingStatus = (state: any) => state.loading.value;
export default loadingSlice.reducer;